__turbopack_context__.v({
  "className": "poppins_db7350bb-module__BY6sCG__className",
  "variable": "poppins_db7350bb-module__BY6sCG__variable",
});
